import Base from '@studiometa/js-toolkit';
import { isDev } from './config';
import ProfileSelector from './components/ProfileSelector';
import Table from './components/Table';
import ScrollToAnchor from './components/ScrollToAnchor';
import Header from './components/Header';
import LangSwitcher from './components/LangSwitcher';
import SearchFooter from './components/SearchFooter';
import Alert from './components/Alert';
import Modal from './components/Modal';
import Filters from './components/Filters';
import HiringSelect from './components/Select/Hiring';
import TabNav from './components/TabNav';
import GoToTab from './components/GoToTab';
import ShowMore from './components/ShowMore';
import Slider from './components/Slider';
import ClipCopy from './components/ClipCopy';
import ContactSidePopin from './components/ContactSidePopin';
import ImageZoom from './components/ImageZoom';
import ScrollingCarousel from './components/ScrollingCarousel';
import AxeptioLink from './components/AxeptioLink';
import ScrollTo from './components/ScrollTo';
import Accordion from './components/Accordion';
import MobileReadmoreAccordion from './components/MobileReadmoreAccordion';
import StickyBanner from './components/StickyBanner';
import ProfilTopHeader from './components/ProfilTopHeader';
import ProfilSelectorHomepage from './components/ProfilSelectorHomepage';

/**
 * App class.
 */
class App extends Base {
  /**
   * App configuration.
   * @return {Object}
   */
  get config() {
    return {
      name: 'App',
      log: isDev(),
      components: {
        '#block-em-profile-selector': ProfileSelector,
        '.wysiwyg table': Table,
        'a[href*="#"]': ScrollToAnchor,
        Accordion,
        MobileReadmoreAccordion,
        Header,
        LangSwitcher,
        SearchFooter,
        Alert,
        Modal,
        Filters,
        HiringSelect,
        TabNav,
        GoToTab,
        ShowMore,
        Slider,
        ClipCopy,
        ContactSidePopin,
        ImageZoom,
        ScrollingCarousel,
        AxeptioLink,
        ScrollTo,
        StickyBanner,
        ProfilTopHeader,
        ProfilSelectorHomepage,
        Pager: () => import('./components/Pager'),
        UniversityViewSwitch: () => import('./components/UniversityViewSwitch'),
        TrainingSelector: () =>
          import(/* webpackChunkName: "TrainingSelector" */ './components/TrainingSelector'),
        Mapbox: () => import(/* webpackChunkName: "Mapbox" */ './components/Mapbox'),
        MapboxUniversity: () =>
          import(/* webpackChunkName: "MapboxUniversity" */ './components/MapboxUniversity'),
        Strasbourg: () => import(/* webpackChunkName: "Strasbourg" */ './components/Strasbourg'),
        OurValues: () => import(/* webpackChunkName: "OurValues" */ './components/OurValues'),
      },
    };
  }

  /**
   * Get primary TabNav
   */
  get tabNav() {
    return this.$children.TabNav[0];
  }

  /**
   * Scroll to current hash
   */
  scrollToCurrentHash() {
    if (!document.location.hash) {
      return;
    }

    const target = document.querySelector(document.location.hash) || null;
    if (!target) {
      return;
    }

    // Specific case for profilselectorHomepage
    const elementTop =
      document.location.hash === '#push-profiles-homepage'
        ? target.offsetTop - 200
        : target.offsetTop;

    window.scrollTo({
      top: elementTop,
      behavior: 'smooth',
    });
  }

  /**
   * Mounted
   */
  mounted() {
    this.scrollToCurrentHash();
  }
}

let app;

// We need to wait for the page load before instantiating the App class because when you are
// connected to the BO the DOM is loaded weirdly and some child components are not detected
// and thus not intantiated nore mounted.
window.addEventListener('load', () => {
  app = new App(document.documentElement);
  window.app = app;
});

export default () => app;
